class StickyAddToCart extends HTMLElement {
    constructor() {
        super();


        const contentElement = this.querySelector("sticky-add-to-cart-content");
        this.layout_type = contentElement
            ? contentElement.getAttribute("layout-type")
            : null;


        this.drawerType = this.querySelector("[drawer-to-open]") ? this.querySelector("[drawer-to-open]").getAttribute("drawer-to-open") : "sticky-add-to-cart-drawer"


        this.variantList = this.querySelector("[sticky-add-to-cart-variants]");
        this.addToCartButton = this.querySelector("[add-to-cart-button]");

        document.addEventListener(_EVENT_HELPER.updateStickyAddToCartContent, this._updateStickyAddToCartContent.bind(this));
        document.addEventListener(_EVENT_HELPER.updateStickyAddToCartContentUnAvailable, this._updateStickyAddToCartContentUnAvailable.bind(this));



    }



    _updateStickyAddToCartContent(e) {
        let content_list = e.detail.sticky_content
        content_list.forEach(element => {

            let stickyElement = element.querySelector("sticky-add-to-cart-content")
            if (
                stickyElement &&
                stickyElement.getAttribute("layout-type") === this.layout_type
            ) {
                this.querySelector("[sticky-add-to-cart-content]").innerHTML = element.innerHTML
            }
        });

    }

    _updateStickyAddToCartContentUnAvailable(e) {
        if (this.variantList) {
            this.variantList.textContent = e.detail.variantOptions.join(", ")
        }
        this.togleAddToCartButton(false)
    }

    disconnectedCallback() {

        document.removeEventListener(_EVENT_HELPER.updateStickyAddToCartContent, this._updateStickyAddToCartContent.bind(this));
    }

    togleAddToCartButton(buttonEnabled) {
        if (this.addToCartButton) {
            if (buttonEnabled) {
                this.addToCartButton.removeAttribute("disabled")
            }
            else {
                if (!this.addToCartButton.classList.contains("sticky-icon-button")) {
                    this.addToCartButton.textContent = window.variantStrings.unavailable
                }
                this.addToCartButton.removeAttribute("form")
                this.addToCartButton.setAttribute("disabled", true);
            }
        }
    }


}
window.customElements.define('sticky-add-to-cart', StickyAddToCart);


class StickyAddToCartContent extends HTMLElement {
    constructor() {
        super();
        this.buttonContainer = this.querySelector("[stikcy-add-to-cart-button-content]")
        this._product_container = document.querySelector('[product-container]');
        this._drawerScrollToSection = document.querySelector("drawer-component [scroll-to-section]")
        this._scrollToSectionButton = this.querySelector("[scroll-to-section]")

        this._boundAddToCartClick = this._handleAddToCartClick.bind(this);
        this._boundResetStickyButton = this._resetStickyButtons.bind(this);
        this._boundScrollHandler = this._scrollHandler.bind(this);
        this._boundScreenResize = this.screenResize.bind(this);
        this._boundScrollToSection = this._scrollToSection.bind(this);

        this.breakpoint = window.matchMedia('(min-width:768px)');
        this.addEventListener("click", this._boundAddToCartClick);
        document.addEventListener(_EVENT_HELPER.resetStickyAddTocartButton, this._boundResetStickyButton)
        document.addEventListener('scroll', this._boundScrollHandler);
        window.addEventListener('resize', this._boundScreenResize);
        document.addEventListener(_EVENT_HELPER.triggerVariantAddToCartError, (e) => {
            this.componentState = this.closest("sticky-add-to-cart").getAttribute("aria-hidden")
            if (this.componentState === "false") {
                this._scrollToSection(e)
            }
        })
        this._scrollToSectionButton?.addEventListener("click", this._boundScrollToSection)
        this._drawerScrollToSection && this._drawerScrollToSection.addEventListener("click", this._boundScrollToSection)
        this.scrollTosection = this._scrollToSectionButton?.getAttribute("scroll-to-section") || this._drawerScrollToSection?.getAttribute("scroll-to-section");
        this.scrollTosectionElement = document.querySelector(`#shopify-section-${this.scrollTosection} [variant-block]`)

    }
    connectedCallback() {
        if (!this._product_container) return;
        this._product_containerOffsetTop = this._product_container.offsetTop;
        this._product_containerHeight = this._product_container.offsetHeight;
        this._totalScrollHeight = this._product_containerOffsetTop + this._product_containerHeight;
        this.screenResize();
    }

    _scrollToSection(e) {
        e.preventDefault()

        HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.hideDrawer, this, {
            drawerType: this.drawerType,
        });
        this.scrollTosectionElementOffset > 0 &&
            window.scrollTo({
                top: this.scrollTosectionElementOffset,
                behavior: 'smooth'
            })
    }
    _handleAddToCartClick(e) {
        const button = e.target.closest("[add-to-cart-button]");
        if (!button || !this.contains(button) || button.hasAttribute("disabled")) return;

        e.preventDefault();

        const formId = button.getAttribute("form");
        if (!formId) return;

        const targetForm = document.getElementById(formId);
        if (!targetForm) return;

        HELPER_UTIL.submitButtonState(button).loadingState();
        HELPER_UTIL.dispatchCustomEvent('submit', targetForm)
    }
    _resetStickyButtons() {
        const buttons = this.querySelectorAll("[add-to-cart-button]");
        buttons.forEach((button) => {
            HELPER_UTIL.submitButtonState(button).resetState(
                1000
            );
            HELPER_UTIL.submitButtonState(button).disableState(
                false
            );
        });
    }
    screenResize() {
        if (this.breakpoint.matches === true) {
            this.scrollTosectionElementOffset = this.scrollTosectionElement ? this.scrollTosectionElement?.offsetTop + this._product_container?.offsetTop : 0

        } else {
            this.scrollTosectionElementOffset = this.scrollTosectionElement ? document.querySelector("[scroll-product-info]")?.offsetTop + this.scrollTosectionElement?.offsetTop : 0
        }
    }
    _scrollHandler() {

        if (window.scrollY > this._totalScrollHeight) {
            this.closest("sticky-add-to-cart")?.classList.add("active")
            /* this will add a class to the body to make the Announcement popup button visible */
            // document.body.classList.add("sticky-add-to-cart-active")
        } else {
            this.closest("sticky-add-to-cart")?.classList.remove("active")
            /* this will remove a class from the body to make the Announcement popup button invisible */
            // document.body.classList.remove("sticky-add-to-cart-active")
        }
    }

    disconnectedCallback() {
        this.removeEventListener("click", this._boundAddToCartClick);
        document.removeEventListener(_EVENT_HELPER.resetStickyAddTocartButton, this._boundResetStickyButton)
        document.removeEventListener('scroll', this._boundScrollHandler);
        window.removeEventListener('resize', this._boundScreenResize);
        this._scrollToSectionButton && this._scrollToSectionButton.removeEventListener("click", this._boundScrollToSection)
        this._drawerScrollToSection && this._drawerScrollToSection.removeEventListener("click", this._boundScrollToSection)
    }
}

window.customElements.define('sticky-add-to-cart-content', StickyAddToCartContent);
